"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReverseContentSection = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var BreakpointsProvider_1 = require("@cvent/carina/components/Breakpoints/BreakpointsProvider");
var Col_1 = require("@cvent/carina/components/Col");
var Row_1 = require("@cvent/carina/components/Row");
var useRowMargins_1 = __importDefault(require("../../hooks/useRowMargins"));
function ContentSection(_a) {
    var textContent = _a.textContent, mediaContent = _a.mediaContent, stackOnMedium = _a.stackOnMedium, _b = _a.reverseWhenStacked, reverseWhenStacked = _b === void 0 ? false : _b;
    var _c = (0, BreakpointsProvider_1.useBreakpoints)(), isDefaultSize = _c.isDefaultSize, isS = _c.isS, isM = _c.isM;
    var rowMargins = (0, useRowMargins_1.default)();
    var singleColumn = isDefaultSize || isS || (isM && stackOnMedium);
    if (singleColumn && reverseWhenStacked) {
        return ((0, jsx_runtime_1.jsx)(ReverseContentSection, { textContent: textContent, mediaContent: mediaContent, reverseWhenStacked: false, stackOnMedium: stackOnMedium }));
    }
    return ((0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({ justifyContent: "center", margin: rowMargins }, { children: [(0, jsx_runtime_1.jsx)(Col_1.Col, __assign({}, {
                flex: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                },
                width: 4 / 4,
                s: { width: 4 / 4 },
                m: stackOnMedium ? { width: 4 / 4 } : { width: 2 / 4 },
                l: { width: 5 / 12, offset: 1 / 12, offsetEnd: 1 / 12 },
                xl: { width: 4 / 12, offset: 2 / 12, offsetEnd: 1 / 12 }
            }, { children: textContent })), (0, jsx_runtime_1.jsx)(Col_1.Col, __assign({}, {
                padding: {
                    top: singleColumn ? 32 : undefined
                },
                flex: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                },
                width: 4 / 4,
                s: { width: 4 / 4 },
                m: stackOnMedium ? { width: 4 / 4 } : { width: 2 / 4 },
                l: { width: 4 / 12, offset: 0, offsetEnd: 1 / 12 },
                xl: { width: 3 / 12, offset: 0, offsetEnd: 2 / 12 }
            }, { children: mediaContent }))] })));
}
function ReverseContentSection(_a) {
    var textContent = _a.textContent, mediaContent = _a.mediaContent, stackOnMedium = _a.stackOnMedium, _b = _a.stackOnSmall, stackOnSmall = _b === void 0 ? true : _b, _c = _a.reverseWhenStacked // set to true to keep backwards compatibility with stackOnSmall prop
    , reverseWhenStacked = _c === void 0 ? true : _c // set to true to keep backwards compatibility with stackOnSmall prop
    ;
    var _d = (0, BreakpointsProvider_1.useBreakpoints)(), isDefaultSize = _d.isDefaultSize, isS = _d.isS, isM = _d.isM;
    var rowMargins = (0, useRowMargins_1.default)();
    var singleColumn = isDefaultSize || isS || (isM && stackOnMedium);
    if (singleColumn && stackOnSmall && reverseWhenStacked) {
        return ((0, jsx_runtime_1.jsx)(ContentSection, { textContent: textContent, mediaContent: mediaContent, reverseWhenStacked: false, stackOnMedium: stackOnMedium }));
    }
    return ((0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({ justifyContent: "center", margin: rowMargins }, { children: [(0, jsx_runtime_1.jsx)(Col_1.Col, __assign({}, {
                flex: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                },
                width: 4 / 4,
                s: { width: 4 / 4 },
                m: stackOnMedium ? { width: 4 / 4 } : { width: 2 / 4 },
                l: { width: 4 / 12, offset: 1 / 12, offsetEnd: 1 / 12 },
                xl: { width: 3 / 12, offsetEnd: 1 / 12 }
            }, { children: mediaContent })), (0, jsx_runtime_1.jsx)(Col_1.Col, __assign({}, {
                padding: {
                    top: singleColumn ? 32 : undefined
                },
                flex: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                },
                width: 4 / 4,
                s: { width: 4 / 4 },
                m: stackOnMedium ? { width: 4 / 4 } : { width: 2 / 4 },
                l: { width: 5 / 12, offsetEnd: 1 / 12 },
                xl: { width: 4 / 12 }
            }, { children: textContent }))] })));
}
exports.ReverseContentSection = ReverseContentSection;
exports.default = ContentSection;
//# sourceMappingURL=ContentSection.js.map